// Sort dockets by service time if completed, and by location if not
const sortServiceDockets = (a, b) => {
	if (a.date !== null && b.date !== null) {
		return a.date - b.date;
	}
	if (a.date === null && b.date !== null) {
		return 1;
	}
	if (b.date === null && a.date !== null) {
		return -1;
	}
	return a.order - b.order;
};

export default sortServiceDockets;
